'use strict';
const angular = require('angular');

export class ContactLookupComponent {
  /*@ngInject*/
  constructor(ContactService) {
    this.ContactService = ContactService;
    this.dtInstance = {};
    
    this.data = [];

    this.selected = {};
  }

  $onInit() {
    this.config = this.resolve.config;

    this.ContactService.query((data) => {
      if (this.config && this.config.exclude) {
        let excludeList = Array.isArray(this.config.exclude) ? this.config.exclude : [this.config.exclude];
        this.data = data.filter(contact => !excludeList.includes(String(contact._id)));
      } else {
        this.data = data;
      }

      if (this.config.multiple && this.config.checkAll)
        this.checkAll();

      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve contacts.")
    });


  }

  checkAll() {

    var that = this;

    var api = this.dtInstance.DataTable;
    api.rows({ search:'applied' }).every(function() {

      let _id = api.cell({ row:this.index(), column:0 })
        .nodes()
        .to$()
        .find('span')[0]
        .getAttribute('x-filter-id');

      that.selected[_id] = true;
    });
    this.dtInstance.DataTable.draw();
  }

  uncheckAll() {
    var that = this;

    var api = this.dtInstance.DataTable;
    api.rows({ search:'applied' }).every(function() {

      let _id = api.cell({ row:this.index(), column:0 })
        .nodes()
        .to$()
        .find('span')[0]
        .getAttribute('x-filter-id');

      that.selected[_id] = false;
    });
    this.dtInstance.DataTable.draw();
  }

  getSelectedCount() {
    return this.data.filter(wa => this.selected[wa._id]).map(wa => wa._id).length;
  }

  okMultiple() {
    let selectedData = this.data.filter(ppty => this.selected[ppty._id]).map(ppty => ppty._id);
    this.close({$value: selectedData});
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  getPrimaryEmailSoftBreak(contact) {
    let email = this.getPrimaryEmail(contact);

    return email
      .replace('@','@&#8203;')
      .replace('.','&#8203;.')
      .replace('-','-&#8203;')
      .replace('_','_&#8203;');
  }

  getPrimaryPhone(contact) {
    if (!contact || !contact.phone || !contact.phone.length)
      return "-";

    let phone = contact.phone.find(phone => phone.isPrimary) || contact.phone[0] || {number:'-'};

    return phone.number;
  }

  getPrimaryAddress(contact) {
    if (!contact || !contact.address || !contact.address.length)
      return "-";

    let address = contact.address.find(adr => adr.isPrimary) || contact.address[0] || {};

    return address.street + "<br/>" + address.city + ' ' + address.state + ', ' + address.zip;
  }

  ok(contact) {
    this.close({$value: contact});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.contactLookup', [])
  .component('contactLookup', {
    template: require('./contact-lookup.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: ContactLookupComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/contact-lookup/contact-lookup.component.js